import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useEMarketplaceLayoutContext } from './EMarketplaceLayoutContext';

export default function Breadcrumb(props: { fixed?: boolean }) {
  const { fixed } = props;
  const { breadcrumb } = useEMarketplaceLayoutContext();
  const { t } = useTranslation();

  if (!breadcrumb || breadcrumb.length === 0) {
    return <></>;
  }

  return (
    <nav className={classNames('navbar', { fixed: fixed })}>
      <div className="container">
        <ol className="breadcrumb">
          {breadcrumb.map((item, idx) => (
            <li
              key={idx}
              id={item.to === '/pi' ? 'pi-header-lnk-home-page' : 'pi-headrer-txt-my-cart'}
              className={classNames('breadcrumb-item', {
                active: idx === breadcrumb.length - 1,
              })}
            >
              {item.to ? (
                <Link to={item.to}>{t(item.title)}</Link>
              ) : (
                t(item.title, { nsSeparator: false })
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
